<div class="flex flex-col gap-2">
  <div class="flex items-center justify-between gap-2">
    <div class="text-base font-bold">Automations</div>
    <a href="javascript:void(0);" (click)="openAutomations()">Edit</a>
  </div>
  <pr-appointment-automations-summary [automations]="automations$ | async" />
</div>
